import { useLocation } from "react-router-dom";

//TODO: Refactor and use matchPath
export const currentRoute = (route) => {
  const location = useLocation();

  const isCurrentRoute = location.pathname === route;

  return { location, isCurrentRoute };
};
